import { Menu, MenuItem, MenuList, MenuPopover, MenuTrigger } from '@fluentui/react-components';
import { MenuButton } from '@shared/components/MenuButton';
import { PROJECT_STATUSES, PROJECT_STATUS_METADATA } from '../constants';
import type { EProjectStatus } from '../types';
import ProjectStatusIcon from './ProjectStatusIcon';

const ProjectStatusMenu = ({
  status,
  disabled,
  onStatusChange,
}: {
  status: EProjectStatus;
  disabled: boolean;
  onStatusChange: (status: EProjectStatus) => void;
}) => (
  <Menu>
    <MenuTrigger disableButtonEnhancement>
      <MenuButton disabled={disabled} appearance="secondary">
        <span className="flex items-center space-x-1">
          <ProjectStatusIcon status={status} size="medium" />
          <span>{PROJECT_STATUS_METADATA[status].label}</span>
        </span>
      </MenuButton>
    </MenuTrigger>
    <MenuPopover>
      <MenuList>
        {PROJECT_STATUSES.filter((option) => option.value !== status).map((option) => (
          <MenuItem
            key={option.value}
            icon={<ProjectStatusIcon status={option.value} />}
            onClick={() => onStatusChange(option.value)}
          >
            {option.label}
          </MenuItem>
        ))}
      </MenuList>
    </MenuPopover>
  </Menu>
);

export default ProjectStatusMenu;
